// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  ResultSummary,
  ResultSummaryFromJSON,
  ResultSummaryToJSON,
  TestPlanConfiguration,
  TestPlanConfigurationFromJSON,
  TestPlanConfigurationToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestPlanRegression
 */
export interface TestPlanRegression {
  /**
   *
   * @type {number}
   * @memberof TestPlanRegression
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof TestPlanRegression
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof TestPlanRegression
   */
  iteration: number;
  /**
   *
   * @type {Array<string>}
   * @memberof TestPlanRegression
   */
  testCaseSelection: Array<TestPlanRegressionTestCaseSelectionEnum>;
  /**
   *
   * @type {Array<UserMinified>}
   * @memberof TestPlanRegression
   */
  assignedTo?: Array<UserMinified>;
  /**
   * 0 = Draft; 1 = Ready to execute; 2 = Finish; 3 = Finished (with failures); 4 = Archived
   * @type {number}
   * @memberof TestPlanRegression
   */
  status: TestPlanRegressionStatusEnum;
  /**
   *
   * @type {ResultSummary}
   * @memberof TestPlanRegression
   */
  result?: ResultSummary;
  /**
   *
   * @type {number}
   * @memberof TestPlanRegression
   */
  testplan?: number;
  /**
   *
   * @type {BuildMinified}
   * @memberof TestPlanRegression
   */
  build?: BuildMinified;
  /**
   * Time spent on execution of this plan (in seconds)
   * @type {number}
   * @memberof TestPlanRegression
   */
  timeSpent: number;
  /**
   *
   * @type {UserMinified}
   * @memberof TestPlanRegression
   */
  createdBy: UserMinified;
  /**
   * Time when the regression was created
   * @type {string}
   * @memberof TestPlanRegression
   */
  createdAt?: string;
  /**
   * Time when the regression was created
   * @type {string}
   * @memberof TestPlanRegression
   */
  updatedAt?: string;
  /**
   *
   * @type {Array<TestPlanConfiguration>}
   * @memberof TestPlanRegression
   */
  configurations?: Array<TestPlanConfiguration>;
  /**
   *
   * @type {string}
   * @memberof TestPlanRegression
   */
  lastActivity: string;
  /**
   * If queue id is returned then the task is still in progress
   * @type {number}
   * @memberof TestPlanRegression
   */
  pendingQueueId?: number;
}

export function TestPlanRegressionFromJSON(json: any): TestPlanRegression {
  return {
    id: json["id"],
    title: json["title"],
    iteration: json["iteration"],
    testCaseSelection: json["test_case_selection"],
    assignedTo: !exists(json, "assigned_to")
      ? undefined
      : (json["assigned_to"] as Array<any>).map(UserMinifiedFromJSON),
    status: json["status"],
    result: !exists(json, "result")
      ? undefined
      : ResultSummaryFromJSON(json["result"]),
    testplan: !exists(json, "testplan") ? undefined : json["testplan"],
    build: !exists(json, "build")
      ? undefined
      : BuildMinifiedFromJSON(json["build"]),
    timeSpent: json["time_spent"],
    createdBy: UserMinifiedFromJSON(json["created_by"]),
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
    configurations: !exists(json, "configurations")
      ? undefined
      : (json["configurations"] as Array<any>).map(
          TestPlanConfigurationFromJSON
        ),
    lastActivity: json["last_activity"],
    pendingQueueId: !exists(json, "pending_queue_id")
      ? undefined
      : json["pending_queue_id"],
  };
}

export function TestPlanRegressionToJSON(value?: TestPlanRegression): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    title: value.title,
    iteration: value.iteration,
    test_case_selection: value.testCaseSelection,
    assigned_to:
      value.assignedTo === undefined
        ? undefined
        : (value.assignedTo as Array<any>).map(UserMinifiedToJSON),
    status: value.status,
    result: ResultSummaryToJSON(value.result),
    testplan: value.testplan,
    build: BuildMinifiedToJSON(value.build),
    time_spent: value.timeSpent,
    created_by: UserMinifiedToJSON(value.createdBy),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    configurations:
      value.configurations === undefined
        ? undefined
        : (value.configurations as Array<any>).map(TestPlanConfigurationToJSON),
    last_activity: value.lastActivity,
    pending_queue_id: value.pendingQueueId,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TestPlanRegressionTestCaseSelectionEnum {
  PASSED = "PASSED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
  BLOCKED = "BLOCKED",
}
/**
 * @export
 * @enum {string}
 */
export enum TestPlanRegressionStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
  NUMBER_4 = 4,
}
